;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Logger } from '@qogita/logger'

import {
  Tracker,
  TrackingEventList,
  TrackingEventName,
  TrackingEventProperties,
} from './types'

/**
 * Creates a single interface to track events to multiple destinations with a single `.track()` call.
 *
 * This should be the main entry point for tracking events in an application
 *
 * @example
 * ```ts
 * const browserTracker = new TrackingAggregator({
 *   destinations: [
 *     segmentTrackingDestination,
 *     googleAnalyticsTrackingDestination,
 *   ],
 * })
 *
 * browserTracker.track('test', { some: 'property' })
 * ```
 */
export class TrackingAggregator<
  TEventList extends TrackingEventList = never,
> implements Tracker<TEventList> {
  #destinations: Tracker<TEventList>[]
  #logger: Logger

  constructor({
    destinations,
    logger,
  }: {
    destinations: Tracker<TEventList>[]
    logger: Logger
  }) {
    this.#destinations = destinations
    this.#logger = logger
  }

  async track<TEventName extends TrackingEventName<TEventList>>(
    event: TEventName,
    properties: TrackingEventProperties<TEventList, TEventName>,
  ) {
    await Promise.all(
      this.#destinations.map(async (destination) => {
        try {
          await destination.track(event, properties)
        } catch (error) {
          this.#logger.error(error)
        }
      }),
    )
  }
}
